// extracted by mini-css-extract-plugin
export var dropdownButton = "_2s-0";
export var fullWidthDropdownButton = "_2s-1";
export var icon = "_2s-3";
export var iconPlaceholder = "_2s-2";
export var menuItemRow = "_2s-9";
export var separator = "_2s-e";
export var shortcutContainer = "_2s-7";
export var shortcutContainerFilled = "_2s-8";
export var shortcutIconLg = "_2s-6";
export var shortcutIconMd = "_2s-5";
export var shortcutIconSm = "_2s-4";
export var submenuChevron = "_2s-d";
export var submenuDropdown = "_2s-a";
export var submenuTriggerRow = "_2s-b";
export var submenuTriggerRowOpen = "_2s-c";